import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GraphQLModule } from './graphql.module';
import { AppRoutingModule } from './app-routing-module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



import { 
  ApiService, 
  AppMaterialComponentsModule, 
  ContractorApiService, 
  ContractorGqlService, 
  ZipCodeApiService, 
  ZipCodeGqlService, 
  ContractorSearchModule,
  DialogSolutionDeployingComponent, 
  AppLoadService
} from '@ebb-v2/ebb-integration';
import { ContractorSearchAppComponent } from './app.component';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import {  NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

@NgModule({
  declarations: [
    ContractorSearchAppComponent, 
    DialogSolutionDeployingComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    AppMaterialComponentsModule,
    AppRoutingModule,
    FormsModule,
    GraphQLModule,
    ContractorSearchModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [
    ApiService,provideNgxMask(),
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
    { provide: ContractorApiService, useClass: ContractorGqlService },
    { provide: ZipCodeApiService, useClass: ZipCodeGqlService },
  ],
  bootstrap: [ContractorSearchAppComponent]
})
export class ContractorSearchAppModule {}






